export default __webpack_public_path__ + "static/media/logo.103b5fa1.svg";